import * as i0 from "@angular/core";
export class PaymentInfoStore {
}
PaymentInfoStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PaymentInfoStore_Factory() { return new PaymentInfoStore(); }, token: PaymentInfoStore, providedIn: "root" });
export var PaymentInfoStoreKeys;
(function (PaymentInfoStoreKeys) {
})(PaymentInfoStoreKeys || (PaymentInfoStoreKeys = {}));
